import React, { forwardRef, memo } from 'react'

const WalletIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56"
      height="56"
      viewBox="0 0 80 80"
      fill="none"
      {...props}>
      <circle
        cx="40"
        cy="40"
        r="38.387"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="3.227"
      />
      <path
        d="M51 30H29C28.4477 30 28 30.4477 28 31V49C28 49.5523 28.4477 50 29 50H51C51.5523 50 52 49.5523 52 49V31C52 30.4477 51.5523 30 51 30Z"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45 35C45 36.3261 44.4732 37.5979 43.5355 38.5355C42.5979 39.4732 41.3261 40 40 40C38.6739 40 37.4021 39.4732 36.4645 38.5355C35.5268 37.5979 35 36.3261 35 35"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

WalletIcon.displayName = 'WalletIcon'

export default memo(WalletIcon)
